import { formatAssetName } from 'utils/strings'

export const isLandingPageLogoAssetType = (assetTypeName?: string): boolean =>
  formatAssetName(assetTypeName ?? '') === 'logo'

/** User-facing labels for LP logo desktop/mobile slots (add/edit forms + AI). */
export const LP_LOGO_FIELD_LABELS = {
  image: 'Logo (desktop)',
  attributeAlt: 'Alt (desktop)',
  largeImage: 'Logo (mobile)',
  attributeAltMobile: 'Alt (mobile)'
} as const

export const LP_LOGO_LARGE_IMAGE_TOOLTIP =
  'Mobile logo image shown below the desktop breakpoint.'
